<div class="flex flex-col h-auto gap-4 side-padding sm:px-0">
  <div
    class="flex flex-col w-full gap-3 p-5 pb-0 bg-white max-sm:p-3 max-sm:pb-0 rounded-10"
  >
    <div>
      <!-- Case loading -->
      @if(fetchStatusComputed().isLoading) {
      <app-skeleton-preview-details />
      }

      <!-- Case loaded -->
      @if(!fetchStatusComputed().isLoading){

      <app-football-breadcrumbs
        [data]="this.getCompetitionBreadcrumbsData()"
        [entity]="'Team'"
      />

      <app-detail-view [teamInfo]="teamInfo()" />
      }
    </div>
    <app-team-tabs />
  </div>

  @if(!this.fetchStatusComputed().isError &&
  !this.fetchStatusComputed().isLoading && this.teamInfo()) {
  <!-- Tabs -->

  @switch (selectedHeaderTab()) {
  <!-- MATCHES -->
  @case (0) {
  <app-matches />
  }
  <!-- RESULTS -->
  @case (1) {
  <app-results />
  }
  <!-- STANDING -->
  @case (2) {
  <app-standing [teamId]="teamId()" />
  }
  <!-- EQUIPMENT -->
  @case (3) {
  <app-equipment />
  }
  <!-- DEFAULT -->
  @default {
  <app-no-result message="NotAvalaibleInformation" />
  } }}
</div>
